import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '@/hooks/useTranslation';

interface SeoProps {
  title?: string;
  description?: string;
  canonical?: string;
  noindex?: boolean;
  og?: {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
  };
}

const Seo = ({
  title,
  description,
  canonical,
  noindex = false,
  og,
}: SeoProps) => {
  const { t } = useTranslation();
  const defaultTitle = t('general.appName');
  const defaultDescription = t('home.hero.description');
  const siteUrl = 'https://www.splusd-solutions.com';

  const pageTitle = title 
    ? `${title} | ${defaultTitle}` 
    : defaultTitle;
  
  const metaDescription = description || defaultDescription;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      <html lang="de" />
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      {canonical && <link rel="canonical" href={canonicalUrl} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={og?.type || 'website'} />
      <meta property="og:url" content={og?.url || canonicalUrl} />
      <meta property="og:title" content={og?.title || pageTitle} />
      <meta property="og:description" content={og?.description || metaDescription} />
      {og?.image && <meta property="og:image" content={og.image} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={og?.url || canonicalUrl} />
      <meta name="twitter:title" content={og?.title || pageTitle} />
      <meta name="twitter:description" content={og?.description || metaDescription} />
      {og?.image && <meta name="twitter:image" content={og.image} />}
    </Helmet>
  );
};

export default Seo; 